import { useMemo } from "react";

export interface StatusMappingSectionText {
  sectionTitle: string;
  columnPlaceholder: string;
  sourcePlaceholder: string;
  sourceStatusHeader: string;
  boardColumnHeader: string;
  switchToColumnView: string;
  switchToSourceView: string;
}

export const useStatusMappingSectionText = (
  t: (key: string) => string,
): StatusMappingSectionText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.statusMapping.${key}`);

    return {
      sectionTitle: tKey("sectionTitle"),
      columnPlaceholder: tKey("columnPlaceholder"),
      sourcePlaceholder: tKey("sourcePlaceholder"),
      sourceStatusHeader: tKey("sourceStatusHeader"),
      boardColumnHeader: tKey("boardColumnHeader"),
      switchToColumnView: tKey("switchToColumnView"),
      switchToSourceView: tKey("switchToSourceView"),
    };
  }, [t]);
};
